// Turnstile configuration
const turnstileConfig = {
  // Set to false to use actual verification even in development
  isDevelopment: false,
  
  // Turnstile keys
  siteKey: '0x4AAAAAAA9RkU3-rGZLhI2f',
  secretKey: '0x4AAAAAAA9RkUN_Ui7J7wU1MySmwlnYbEc',
  
  // Script URL
  scriptUrl: 'https://challenges.cloudflare.com/turnstile/v0/api.js'
};

export default turnstileConfig;